<template>
  <div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col" class="text-uppercase">Aranžman</th>
            <th scope="col" class="text-uppercase text-right">Cijena aranžmana po osobi</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="_item in prices">
            <tr :key="_item.id" class="bg-light">
              <td>
                <div class="d-flex flex-column">
                  <span class="font-weight-bold" v-html="_item.name"></span>
                  <span v-if="_item.service">{{ 'Usluga: ' + _getServiceName(_item.service) }}</span>
                  <span
                    v-if="_item.checkinDate && _item.checkoutDate"
                    v-html="`Termin: ${_item.checkinDate} - ${_item.checkoutDate}`"
                    class="mt-1"
                  ></span>
                </div>
              </td>
              <td class="text-right">
                <div class="d-flex flex-column align-items-end">
                  <span
                    class="text-primary font-weight-bold mb-1"
                    v-if="_item.price.total_price_per_person"
                    v-html="$priceFormat(_item.price.total_price_per_person[0])"
                    style="font-size: 1rem;"
                  ></span>
                  <a
                    href="#"
                    class="btn btn-sm btn-outline-primary"
                    data-toggle="modal"
                    :data-target="`#offer-${_item.id}`"
                  >Cijena uključuje</a>
                  <a
                    href="#notes"
                    class="small text-muted"
                    v-if="!_.isEmpty(item.notes)"
                    @click.prevent="goToNotes()"
                  >Doplate</a>
                </div>
              </td>
              <td class="text-right">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="submit($event, _item.id)"
                >Dodaj u košaricu</button>
              </td>
            </tr>
            <tr :key="`${_item.id}-info`" style="background-color: transparent;">
              <td colspan="3" class="px-3">
                <span v-if="_item.transportType" v-html="`Prijevoz: ${_item.transportType}`"></span>
                <div class="d-flex mt-2" v-if="_item.flightOutbound && _item.flightInbound">
                  <div class="d-flex flex-column mr-4">
                    <span class="font-weight-bold">Polazak:</span>
                    <span v-for="flightOutbound in _item.flightOutbound">
                      <span class="d-block" v-html="`${flightOutbound.date}: ${flightOutbound.hour}`"></span>
                      <span class="d-block" v-html="flightOutbound.description"></span>
                      <span class="d-block mb-1" v-html="flightOutbound.duration"></span>
                    </span>

                  </div>
                  <div class="d-flex flex-column">
                    <span class="font-weight-bold">Povratak:</span>
                    <span v-for="flightInbound in _item.flightInbound">
                      <span class="d-block" v-html="`${flightInbound.date}: ${flightInbound.hour}`"></span>
                      <span class="d-block" v-html="flightInbound.description"></span>
                      <span class="d-block mb-1" v-html="flightInbound.duration"></span>
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <template v-for="(_item, _itemKey) in prices">
      <div class="modal fade" :id="`offer-${_item.id}`" :key="`offer-modal-${_itemKey}`">
        <div class="modal-dialog modal-dialog-centered modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Cijena uključuje</h5>
            </div>
            <div class="modal-body">
              <h6 class="mb-1">Smještaj: {{ _item.name }}</h6>
              <span v-if="_item.service">{{ 'Usluga: ' + _getServiceName(_item.service) }}</span>
              <div class="d-flex flex-column align-items-end mt-2">
                <div
                  v-for="(price, i) in _item.price.base_price_per_person"
                  :key="`base-price-${i}`"
                  class="d-flex w-100"
                >
                  <span>{{ getPriceLabel(i) }}</span>
                  <span class="ml-auto text-right" style="width: 100px;">{{ $priceFormat(price) }}</span>
                </div>
              </div>
              <div class="d-flex flex-column align-items-end">
                <div
                  v-for="(price, i) in _item.price.required_payments"
                  :key="`required-payment-${i}`"
                  class="d-flex w-100"
                >
                  <span style="flex: 1;">{{ `${price.surchargeAmount}x ${price.surchargeName}` }}</span>
                  <span
                    class="ml-auto text-right"
                    style="width: 100px;"
                  >{{ $priceFormat(price.surchargePrice) }}</span>
                </div>
              </div>
              <div class="d-flex border-top mt-2 pt-2">
                <span>Ukupno:</span>
                <span
                  class="ml-auto text-right font-weight-bold"
                  style="width: 100px;"
                >{{ $priceFormat(_item.price.total) }}</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-dismiss="modal">Zatvori</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    item: {
      type: Object,
      required: true
    },
    prices: {
      type: Object,
      required: true
    },
    from: {
      type: String,
      required: false,
      default: null
    },
    to: {
      type: String,
      required: false,
      default: null
    },
    adults: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      data: {},
      cart: {}
    };
  },

  beforeMount() {
    Vue.set(this.data, "slug", this.item.slug);
    Vue.set(this.data, "type", "hotel");
    Vue.set(this.data, "source", this.item.source);
    Vue.set(this.data, "items", {});
  },

  // TODO: Move to DB and get as attribute from item
  methods: {
    _getServiceName(name) {
      switch (name) {
        case "Halfboard":
          return "Polupansion";
          break;
        case "Fullboard":
          return "Puni pansion";
          break;
        case "Allinclusive":
          return "All Inclusive";
          break;
        case "Bedandbreakfast":
          return "Noćenje s doručkom";
          break;
        case "Fullboardwithdrinks":
          return "Puni pansion s uključenim pićem";
          break;
        case "Rent":
          return "Najam";
          break;
        case "NoService":
          return "Nema usluga";
          break;
        case "LightallInclusive":
          return "Light All Inclusive";
          break;
        case "Flightonly":
          return "Samo letom";
          break;
        case "Ultraallinclusive":
          return "Ultra All Inclusive";
          break;
        default:
          return name;
      }
    },

    getPriceLabel(i) {
      return i + 1 <= this.adults ? "1x Odrasli" : "1x Dijete";
    },

    goToNotes() {
      document.getElementById("notes").scrollIntoView({
        behavior: "smooth"
      });
    },

    submit(e, id) {
      let btn = e.target;

      Vue.set(this.data, "items", {});
      Vue.set(this.data.items, id, this.prices[id]);
      Vue.set(this.data.items[id], "adults", this.adults);
      Vue.set(
        this.data.items[id],
        "children",
        this.data.items[id].price.base_price_per_person.length - this.adults
      );

      btn.disabled = true;

      this.$nextTick(() => {
        axios
          .post("/naplata", this.data)
          .then(function(response) {
            if (response.data.status == "success") {
              window.location.href = "/naplata";
            } else {
              btn.disabled = false;
            }
          })
          .catch(function(error) {
            btn.disabled = false;

            console.log(error.response);
            console.log(error.response.data);
          });
      });
    }
  }
};
</script>
